
















import Vue from 'vue';

import BaseIcon from '../BaseIcon/BaseIcon.vue';

/**
 * This is a non-interactive wrapper component for `BaseIcon` that specifies
 * button icon classes for an icon inside a `button` tag.
 *
 * Use of this component by itself is not recommended, but should be used as
 * part of other components to obtain the correct styling for icons within
 * buttons.
 *
 * This component only partially implements [Button Icons](http://www.lightningdesignsystem.com/components/button-icons).
 * It does not return a `button` HTML tag. It only returns an icon for use
 * within a button. Assistive text must also be rendered by the parent.
 */
export default Vue.extend({
  components: {
    BaseIcon,
  },
  inheritAttrs: false,
  props: {
    /**
     * Name of the icon category. Visit <a href="http://www.lightningdesignsystem.com/resources/icons">Lightning Design System Icons</a> to reference icon categories.
     */
    category: {
      type: String,
      validator(val: string) {
        return ['utility', 'local'].includes(val);
      },
      default: 'utility',
    },
    size: {
      type: String,
      default: undefined,
    },
    /**
     * Associates an icon button with another element on the page by changes the color of the SVG. Please reference <a href="http://www.lightningdesignsystem.com/components/buttons/#hint">Lightning Design System Buttons > Hint</a>.
     */
    hint: Boolean,
    /**
     * Setting `inverse` to true will switch the color of the icon: light to dark, dark to light.
     */
    inverse: Boolean,
    /**
     * Adds additional spacing on the opposite side specified between button icon and the button label
     */
    position: {
      type: String,
      validator(val: string) {
        return ['left', 'right'].includes(val);
      },
      default: undefined,
    },
  },
});
